const SmsVerify = () => {
    return (
        <>
            Verify phone number
        </>
    )
}

export default SmsVerify